module.exports = __webpack_public_path__ + "static/media/GoogleEarth.2920b192.svg";